/* eslint-disable */
import React, { useState } from 'react';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Button from 'src/onboarding/components/ui/button/Button';
import { MultiImageSelect } from 'src/onboarding/components/ui/multi-image-select/MultiImageSelect';
import { ImageOption } from 'src/onboarding/components/ui/multi-image-select/ImageOption';
import { images } from 'src/onboarding/constants/images';

function Page() {
  const chooseBreakfast = useStore((state) => state.chooseBreakfast);
  const setChooseBreakfast = useStore((state) => state.setChooseBreakfast);
  const [next, setNext] = useState(chooseBreakfast.length > 0);
  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setChooseBreakfast(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.chooseBreakfast.title')}</Title>
        <Text className='description' size='m' medium style={{ padding: '0 35px' }}>
          {t('onboarding.chooseBreakfast.subTitle')}
        </Text>
      </div>

      <div className={'cards'} style={{ marginBottom: 70 }}>
        <MultiImageSelect
        onChange={handleChange}
        defaultValue={chooseBreakfast}
      >
        <ImageOption
          value="Greek yogurt with chia seeds, berries, and granola"
          image={images.breakfast9}
          label={t('onboarding.chooseBreakfast.options.yogurt')}
        />
        
        <ImageOption 
          value="Omelette with tomatoes and basil"
          image={images.breakfast6}
          label={t('onboarding.chooseBreakfast.options.omelette')}
        />
        
        <ImageOption 
          value="Oat pancakes with banana"
          image={images.breakfast4}
          label={t('onboarding.chooseBreakfast.options.pancakes')}
        />
        
        <ImageOption 
          value="Toast with avocado and shrimp/salmon"
          image={images.breakfast7}
          label={t('onboarding.chooseBreakfast.options.toast')}
        />
        <ImageOption 
          value="Scrambled eggs with beans in tomato sauce"
          image={images.breakfast10}
          label={t('onboarding.chooseBreakfast.options.eggs')}
        />
        <ImageOption 
          value="Sandwich with peanut butter and banana, served with Greek yogurt and berries"
          image={images.breakfast12}
          label={t('onboarding.chooseBreakfast.options.sandwich')}
        />
      </MultiImageSelect>
      <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.eatingHabits.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'choose-breakfast',
              answer: chooseBreakfast.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}
export default Page;
